import { render } from "./SubServiceDetail.vue?vue&type=template&id=70c8ca2f&scoped=true"
import script from "./SubServiceDetail.vue?vue&type=script&lang=js"
export * from "./SubServiceDetail.vue?vue&type=script&lang=js"

import "./SubServiceDetail.vue?vue&type=style&index=0&id=70c8ca2f&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c8ca2f"]])

export default __exports__